import React, { useCallback } from "react";
import { Button, Input, Select, createStyles } from "@mantine/core";
import { IconChevronDown, IconSearch } from "@tabler/icons-react";
import { useState, useEffect, useRef } from "react";
import {
  resetSelectedClient,
  searchClient,
  serchMedicinesByStartDate,
  setFilterDates,
  setLogSearch,
} from "../../../../store/reducers/mar";
import store from "../../../../store";
import { DatePickerInput } from "@mantine/dates";
import { getMar, getMarLogsNew, getMedicationLogs } from "../../../../services";
import moment from "moment";
import { useSelector } from "react-redux";
import { FiDownload, FiSearch } from "react-icons/fi";
import { exportBrandedPdf } from "../../../../components/BrandedReport";
import { getDescriptionFields } from "../MarLogTab/MarLogTable/indexNew";
import { decrypt, formatDate, formatTime } from "../../../../utils";
import AddMedicationButton from "../../../../components/AddMedicationButton/AddMedicationButton";

const useStyles = createStyles((theme) => ({
  row: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    background: "#FFF",
    borderRadius: 8,
    padding: "10px 11px",
    height: "fit-content",
    marginBottom: "20px",
    gap: "10px",
    [theme.fn.smallerThan("sm")]: {
      flexDirection: "column",
      alignItems: "stretch",
    },
  },

  filterRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "0 30px",
    borderRadius: "10px",
  },
  searchBox: {
    width: "600px",
    [theme.fn.smallerThan("md")]: {
      width: "100%",
    },
  },
  inputStyle: {
    backgroundColor: "#FFFFFF",
    borderRadius: "8px",
    border: "1px solid #E5E5E5",
    boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
    height: "44px",
    "& .mantine-Input-input": {
      fontFamily: "Inter",
      border: "none",
      backgroundColor: "transparent",
      paddingBlock: "10px",
      fontFamily: "Inter",
      color: "#262626",
      height: "100%",
    },
  },
  filterBar: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    gap: "10px",
    flexWrap: "wrap",
    [theme.fn.smallerThan("sm")]: {
      justifyContent: "flex-start",
      gap: "8px",
    },
  },
  dateBar: {
    height: "50px",
    width: "250px",
    [theme.fn.smallerThan("sm")]: {
      width: "100%",
    },
    // display: "flex",
    // justifyContent: "flex-end",
    // alignItems: "center",
    // "& button": {
    //   width: "250px",
    //   height: "50px",
    // },

    "& .mantine-DatePickerInput-input": {
      height: "50px",
    },
  },
  filter: {
    height: "50px",
    // height: "78.77px",
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",

    "& input": {
      height: "50px",
    },
    "& .mantine-Input-icon": {
      paddingLeft: "20px",
    },
    "& .mantine-Input-input": {
      paddingLeft: "3rem",
    },
    "& img": {
      width: "30px",
      height: "auto",
    },
  },
  marLogDownloadBtn: {
    padding: "12px 20px",
    borderRadius: "8px",
    border: "1px solid #262626",
    backgroundColor: "#262626",
    height: 44,
    boxShadow: "0 1px 2px 0 rgba(16, 24, 40, 0.05)",
    fontSize: 16,
    fontWeight: 600,
    fontFamily: "Inter",
    color: "#FFF",
    ":hover": {
      backgroundColor: "#262626",
      opacity: 0.8,
    },
    "& .mantine-Button-leftIcon": {
      "& svg": {
        color: "#FFF",
        fontSize: "19px",
      },
    },
    [theme.fn.smallerThan("sm")]: {
      fontSize: 13,
      padding: "8px 12px",
      height: 38,
    },
  },
  fieldsStyle: {
    "& .mantine-Input-wrapper": {
      height: "auto",
      backgroundColor: "#FFFFFF",
      borderRadius: "8px",
      border: "1px solid #E5E5E5",
      boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
      "& .mantine-Input-input": {
        fontFamily: "Inter",
        border: "none",
        backgroundColor: "transparent",
        padding: "10px 14px",
        height: "44px",
        fontFamily: "Inter",
        color: "#262626",
      },
      "& .mantine-Textarea-input": {
        height: 153,
        overflowY: "auto",
      },
      "& .mantine-Select-rightSection svg": {
        color: "#667085",
      },
      "& .mantine-DatePickerInput-input": {
        minWidth: "250px",
      },
    },
    "& .mantine-DateInput-wrapper": {
      outline: "4px solid rgb(212, 212, 212, .2)",
      "& .mantine-DateInput-icon": {
        "& svg": {
          color: "#262626",
          fontSize: 18,
        },
      },
      "& .mantine-DateInput-input": {
        paddingLeft: 36,
        fontWeight: 600,
      },
    },
    "& .mantine-InputWrapper-label": {
      color: "#262626",
      marginBottom: "6px",
      fontFamily: "Inter",
      fontSize: "14px",
      fontWeight: 500,
    },
  },
}));

const FilterBar = ({ activeTab, userId }) => {
  console.log("🚀 ~ FilterBar ~ activeTab:", activeTab);
  const { classes } = useStyles();
  const [search, setSearch] = useState("");
  const [value, setValue] = useState([null, null]);
  const [startDate, setStartDate] = useState(null);
  const { filterDates, logType, logSearch, newMarLogs, selectedClient } =
    useSelector((state) => state.mar);
  const { profile } = useSelector((state) => state?.profile);

  const handleDownloadPdf = () => {
    if (!newMarLogs?.allData?.length) return;
    const pdfRows = newMarLogs.allData
      .slice(0)
      .sort((a, b) => new Date(b?.date) - new Date(a?.date))
      .filter((v) => v?.medicationType !== "discontinued")
      .map((row) => {
        const descFields = getDescriptionFields(row);
        const desc =
          descFields
            ?.filter((f) => f.value && f.value !== "-")
            ?.map((f) => `${f.label}: ${f.value}`)
            .join(" | ") || "-";
        return [
          formatDate(row?.createdAt) || "-",
          formatTime(row?.createdAt) || "-",
          row?.logAction || "-",
          decrypt(row?.client?.name) || "-",
          row?.form3?.medicationName || "-",
          row?.createdBy?.name || "-",
          desc,
        ];
      });
    exportBrandedPdf({
      facilityName: profile?.facility?.name,
      reportTitle: "Medication Log",
      reportSubtitle: selectedClient?.name ? decrypt(selectedClient.name) : "",
      columns: [
        "Date",
        "Time",
        "Action",
        "Client",
        "Medication",
        "Action By",
        "Description",
      ],
      rows: pdfRows,
      filename: `Medication_Log_${moment().format("YYYY-MM-DD")}.pdf`,
    });
  };
  // const [value, setValue] = useState("");
  const useDebounce = (value, delay = 500) => {
    const [debouncedValue, setDebouncedValue] = useState("");
    const timerRef = useRef();

    useEffect(() => {
      timerRef.current = setTimeout(() => setDebouncedValue(search), delay);

      return () => {
        clearTimeout(timerRef.current);
      };
    }, [search, delay]);

    return debouncedValue;
  };
  const debouncedValue = useDebounce(value, 500);

  const getData = useCallback(async () => {
    if (activeTab === "medicationList") {
      store.dispatch(searchClient(debouncedValue));
    } else if (activeTab === "marLog") {
      // Dispatch to Redux after debounce — MarLogTab's useEffect watches logSearch
      // and fires the API call. This prevents per-keystroke API calls that caused
      // all logs to flash briefly before the correct filtered results appeared.
      store.dispatch(setLogSearch(debouncedValue));
    }
    // }else if (activeTab === "marLog"){
    //   await getMar(1, null, true,filterDates, logType,debouncedValue,true);
    // }
    else if (activeTab === "medicationLog") {
      await getMedicationLogs(1, null, true, debouncedValue);
    }
  }, [debouncedValue]);

  useEffect(() => {
    getData();
  }, [debouncedValue, getData]);

  return (
    <div className={classes.row}>
      <div className={classes.searchBox}>
      <Input
        id="search-medicine"
        icon={<FiSearch />}
        className={classes.inputStyle}
        placeholder="Search..."
        value={search}
        onChange={(e) => {
          setSearch(e.target.value);
        }}
      />
      </div>
      <div className={classes.filterBar}>
     {/* {activeTab === "medicationList" && ( 
          <div className={classes.dateBar}>
            <DatePickerInput
              id="filter-by-start-date"
              placeholder="Filter by Start Date"
              value={startDate}
              clearable
              onChange={async (date) => {
                setStartDate(date);
                if (date) {
                  let start = moment(date)?.format("YYYY-MM-DD");
                  store.dispatch(serchMedicinesByStartDate(start));
                } else {
                  store.dispatch(resetSelectedClient());
                }
              }}
              className={classes.fieldsStyle}
            />
          </div>
        )} */}
        {activeTab === "marLog" && (
          <div className={classes.dateBar}>
            <DatePickerInput
              id="select-date-range"
              type="range"
              placeholder="Pick dates range"
              value={value}
              clearable
              onChange={async (date) => {
                setValue(date);
                if (date?.[1] !== null) {
                  let start = moment.utc(moment(date?.[0]).format("YYYY-MM-DD")).startOf("day").toISOString();
                  let end = moment.utc(moment(date?.[1]).format("YYYY-MM-DD")).endOf("day").toISOString();
                  store.dispatch(setFilterDates([start, end]));
                  await getMarLogsNew(1, null, true, logSearch || undefined, [start, end]);
                } else if (date?.[0] === null && date?.[1] === null) {
                  store.dispatch(setFilterDates([null, null]));
                  await getMarLogsNew(1, null, true, logSearch || undefined, [null, null]);
                }
              }}
              className={classes.fieldsStyle}
            />
          </div>
        )}

        {activeTab === "marLog" && (
          <>
            <AddMedicationButton
              userId={userId}
              selectedClient={selectedClient}
            />
            <Button
              className={classes.marLogDownloadBtn}
              onClick={handleDownloadPdf}
              disabled={!newMarLogs?.allData?.length}
              leftIcon={<FiDownload />}
            >
              Download Log
            </Button>
          </>
        )}

        {/* <Select
          className={classes.filter}
          icon={<img src={"/assets/images/sort-icon.png"} />}
          data={[
            { value: "month", label: "Month" },
            { value: "week", label: "Week" },
            { value: "day", label: "Day" },
          ]}
          rightSection={<IconChevronDown color={"#FBAA0D"} size={25} />}
          rightSectionWidth={30}
          styles={{ rightSection: { pointerEvents: "none" } }}
        /> */}
      </div>
    </div>
  );
};

export default FilterBar;
